export const BG_VIDEO = "/background_video.mp4";
export const BG_VIDEO_AUTH = "/video/background_auth.mp4";
export const BG_VIDEO_KEY_FEATURES = "/video/background_key_features.mp4";
